export default __webpack_public_path__ + "static/media/cover.72d40bf8.png";